import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import BookGrid from '../components/BookGrid';
import { bookData } from '../data/books';
import SafeIcon from '../common/SafeIcon';
import { FiChevronLeft } from 'react-icons/fi';

const DepartmentDetail = () => {
  const { id } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  const titles = {
    klassiker: "Wiederentdeckte Klassiker",
    demografie: "Demografie & Fachliteratur",
    kinder: "Kinder- und Jugendbücher"
  };

  const descriptions = {
    klassiker: "Vergessene Meisterwerke und zeitlose Literatur in exklusiven Editionen.",
    demografie: "Analysen und Perspektiven auf die gesellschaftlichen Strukturen unserer Zeit.",
    kinder: "Bücher, die begeistern, bilden und die Fantasie beflügeln."
  };

  const currentBooks = bookData[id] || [];

  if (!bookData[id]) return (
    <div className="py-20 text-center text-stone-600 dark:text-stone-400">
      Abteilung nicht gefunden.
    </div>
  );

  return (
    <div className="bg-stone-50 dark:bg-navy-950 min-h-screen pb-24 transition-colors duration-300">
      <div className="bg-brand dark:bg-navy-900 text-white py-20 mb-16 border-b border-transparent dark:border-navy-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center text-stone-400 dark:text-stone-500 hover:text-white mb-8 transition-colors"
          >
            <SafeIcon icon={FiChevronLeft} className="mr-2" /> Zurück zur Übersicht
          </Link>
          <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4">{titles[id]}</h1>
          <p className="text-xl text-stone-300 max-w-2xl">{descriptions[id]}</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center mb-12 border-b border-stone-200 dark:border-navy-800 pb-6">
          <h2 className="text-2xl font-serif font-semibold text-stone-800 dark:text-stone-200">
            Aktuelle Titel ({currentBooks.length})
          </h2>
          <div className="text-stone-500 dark:text-stone-400 text-sm">Sortierung: Neuerscheinungen</div>
        </div>

        <BookGrid books={currentBooks} />
      </div>
    </div>
  );
};

export default DepartmentDetail;
